/**
 * Mock data for the Supply Chain Command Center — used when Runtime APIs are unavailable.
 */

export type SCExceptionType = 'Late shipment' | 'SLA breach risk' | 'Short shipment' | 'PO Mismatch';
export type SCSeverity = 'Low' | 'Medium' | 'High' | 'Critical';

export interface SupplyChainException {
  caseId: string;
  customer: string;
  exceptionType: SCExceptionType;
  slaExposure: number;
  daysOverdue: number;
  severity: SCSeverity;
  recommendation: string;
}

export interface SCMetric {
  label: string;
  value: string;
}

// ─── Mock Supply Chain Exception Rows ────────────────────────────────────────

export const mockSupplyChainExceptions: SupplyChainException[] = [
  {
    caseId: 'SC-2024-118',
    customer: 'Pacific Components',
    exceptionType: 'Late shipment',
    slaExposure: 820000,
    daysOverdue: 3,
    severity: 'Critical',
    recommendation: 'Expedite approval needed',
  },
  {
    caseId: 'SC-2024-124',
    customer: 'NorthStar Logistics',
    exceptionType: 'SLA breach risk',
    slaExposure: 410000,
    daysOverdue: 5,
    severity: 'High',
    recommendation: 'Resolved — fulfilled from alternate DCs',
  },
  {
    caseId: 'SC-2024-137',
    customer: 'Apex Packaging',
    exceptionType: 'Short shipment',
    slaExposure: 275000,
    daysOverdue: 2,
    severity: 'Medium',
    recommendation: 'Supplier response pending',
  },
  {
    caseId: 'SC-2024-142',
    customer: 'Meridian Metals',
    exceptionType: 'PO Mismatch',
    slaExposure: 176400,
    daysOverdue: 0,
    severity: 'High',
    recommendation: 'Price dispute approval needed',
  },
];

// ─── Mock Metrics ────────────────────────────────────────────────────────────

export const mockSCMetrics: SCMetric[] = [
  { label: 'Active supply chain exceptions', value: '48' },
  { label: 'SLA exposure', value: '$3.7M' },
  { label: 'Supplier delays', value: '19' },
  { label: 'Expedite recommendations', value: '11' },
];
